/**
 * Created by zhaoxu on 2018/5/25.
 */
export default function install(Vue) {
  Vue.directive('dom', {
    bind: function (el, binding) {
      var obj = binding.value;
      if (obj != null) {
        var key = Object.keys(binding.modifiers)[0] || "el";
        Vue.set(obj, key, el);
      }
    }
  });
}